/* eslint-disable */
import { ajax } from "noquery-ajax";
import { httpsLogger } from "../p1s7/p1s7e1";

function updateRecyclerLocationLogo(
  recycler_uid: string,
  recycler_location_uid: string,
  content: string
) {
  return new Promise(function (resolve, reject) {
    let params = {
      firebase_uid: window.G_firebase_auth.IV_uid,
      firebase_token: window.G_firebase_auth.IV_id_token,
      recycler_uid: recycler_uid,
      recycler_location_uid: recycler_location_uid,
      p1s3e23_content: content
    };

    ajax({
      url: window.G_cloud_p1s3_base_url + "p1s3e23UpdateRecyclerLocationLogo",
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      dataType: "json",
      data: params,
      success: function (result) {
        let response_data = {
          success: true,
          response: result,
          request_params: params
        }
        resolve(response_data);
      },
      error: function (error) {
        let error_data = {
          success: false,
          request_object: error,
          request_params: params,
          file_name: "p1s3e23.ts",
          class_name: "p1s3e23",
          method_name: "updateRecyclerLocationLogo",
          error_title: "Failed to upload recycler logo.",
          error_description: "The server responded with an error when trying to upload recycler logo",
        };

        httpsLogger(error_data);
        reject(error_data);
      },
    });
  });
}

export default updateRecyclerLocationLogo;
